module.exports = __webpack_public_path__ + "img/banner_3.f7e9681c.jpg";